import { withDependencies } from '@wix/thunderbolt-ioc'
import { IPermissionsHandlerProvider } from '../types'

export const DsPermissionsHandlerProviderFactory = (): IPermissionsHandlerProvider => {
	return {
		getHandler: () => {
			return {
				handle: async (routeInfoFromResponsePromise) => {
					return routeInfoFromResponsePromise
				},
			}
		},
	}
}

export const PermissionsHandlerProvider = withDependencies([], DsPermissionsHandlerProviderFactory)
